import ActivityIcon from '../ActivityIcon.js';
import Ajax from '../../../../../common/js/Ajax.js';
import Form from '../../../../../common/js/form/Form.js';
import MessageUtils from '../../../../../common/js/MessageUtils.js';
import TippspielWidget from '../../TippspielWidget.js';

import TEMPLATE from './ResultsWidget.hbs';

export default class ResultsWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
	}

	isLoginRequired() {
		return true;
	}

	isAdminRequired() {
		return true;
	}

	onLoginReady() {
		Ajax.rpc('/currentSeason', season => {
			this.seasonId = season.id;
			this.$widget.html(TEMPLATE(season));

			this.$widget.find('.js_team').on('change', event => {
				var $match = $(event.currentTarget).closest('.js_match');
				this.saveMatch($match);
			});

			this.$widget.find('.js_goals').on('change', event => {
				var $match = $(event.currentTarget).closest('.js_match');
				this.saveMatch($match);
			});

			Form.onSubmit(this.$widget.find('.js_winner-form'), action => {
				Ajax.rpc('/saveSeasonWinner', {
					seasonId: this.seasonId,
					winnerId: action.findField('winner').val()
				}, () => {
					action.ok();
				}, error => {
					action.error('Aktualisieren des Meisters fehlgeschlagen', error);
				});
			});
		}, error => {
			MessageUtils.error(this.$widget, 'Laden der aktuellen Meisterschaft fehlgeschlagen', error);
		});
	}

	saveMatch($match) {
		var $activityIcon = $match.find('.js_activity-icon');
		if (Form.validate($match).length) {
			ActivityIcon.setNone($activityIcon);
			return;
		}

		var runningId = ActivityIcon.setRunning($activityIcon);
		Ajax.rpc('/saveMatchResults', {
			matchId: $match.attr('data-id'),
			team1Id: $match.find('[name="team1"]').val(),
			team2Id: $match.find('[name="team2"]').val(),
			goals1: $match.find('[name="goals1"]').val().trim(),
			goals2: $match.find('[name="goals2"]').val().trim()
		}, () => {
			ActivityIcon.setSuccess($activityIcon, runningId);
		}, error => {
			ActivityIcon.setNone($activityIcon);
			MessageUtils.error($widget, 'Aktualisieren des Spiels fehlgeschlagen', error);
		});
	}
}
